<div class="avatar-badge" style="width: fit-content">
  <span class="text-label-12 text-dark text-semibold text-nowrap" style="margin-left: 5px;">
    @if (label){
      {{label}}
    }
  </span>
  <nz-avatar
    [nzSize]="24"
    [nzSrc]="avatarUrl"
    [nzText]="!hasAvatar ? initials : undefined"
    [style.backgroundColor]="!hasAvatar ? '#ffffff' : undefined"
    [style.color]="!hasAvatar ? '#000000' : undefined"
    [style.border]="!hasAvatar ? '1px solid #d9d9d9' : undefined"
    [style.fontWeight]="!hasAvatar ? '600' : undefined"
    [nzAlt]="entity?.id"
  ></nz-avatar>
  <span class="text-label-12 text-dark text-semibold text-nowrap">
    {{displayText}}
  </span>
</div>
